import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=logged out

  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) localStorage.setItem("orec_ref", ref);
    // If returning from Google OAuth callback, AuthCallback exchanges the session first
    if (window.location.hash?.includes("session_id=")) return;
    const token = localStorage.getItem("orec_token");
    if (!token) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("orec_token");
      setUser(false);
    });
  }, []);

  const googleSession = async (sessionId) => {
    const role = localStorage.getItem("orec_google_role") || "seeker";
    localStorage.removeItem("orec_google_role");
    try {
      const { data } = await api.post("/auth/google/session", {
        session_id: sessionId, role, ref: localStorage.getItem("orec_ref") || undefined,
      });
      localStorage.removeItem("orec_ref");
      localStorage.setItem("orec_token", data.access_token);
      setUser(data.user);
      return data.user;
    } catch (e) {
      if (!localStorage.getItem("orec_token")) setUser(false);
      throw e;
    }
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("orec_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", {
      ...payload, ref: localStorage.getItem("orec_ref") || undefined,
    });
    localStorage.removeItem("orec_ref");
    localStorage.setItem("orec_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* noop */ }
    localStorage.removeItem("orec_token");
    setUser(false);
  };

  const refresh = () => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {});

  return (
    <AuthContext.Provider value={{ user, login, register, logout, googleSession, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
